import React from 'react';
const pillars = [{
  title: 'Ingeniería',
  detail: 'Cómo vuela realmente la máquina'
}, {
  title: 'Meteorología',
  detail: 'Qué clima mata tu autonomía'
}, {
  title: 'Regulación',
  detail: 'Qué leyes aplican en TU país exactamente'
}, {
  title: 'Negocio',
  detail: 'Cómo cobrar profesionalmente si lo deseas'
}, {
  title: 'Certificación',
  detail: 'Banco de preguntas del examen real'
}];
export function Solution() {
  return <section className="w-full bg-ink-950 py-20 text-white lg:py-28" aria-labelledby="solution-heading" data-id="element-201" data-mp="qtgic4y44vop">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-202" data-mp="vve87i10qoqm">
        <h2 id="solution-heading" className="text-3xl font-black leading-tight tracking-tight sm:text-4xl lg:text-5xl" data-id="element-203" data-mp="hv3fsak2923c">
          Mientras otros están perdidos,{' '}
          <span className="text-flare-500" data-id="element-204" data-mp="mv99rxdsz0ol">tú tienes un mapa completo</span>
        </h2>
        <p className="mx-auto mt-8 max-w-3xl text-lg leading-relaxed text-white/70" data-id="element-205" data-mp="2c69wjak2kgd6">
          Drone Commander NO es “otro tutorial de YouTube” fragmentado. Es el sistema definitivo que
          junta las cinco disciplinas que un piloto necesita dominar.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-content px-6 lg:mt-14" data-id="element-206" data-mp="2ynbyvpfjdrp">
        <div className="grid gap-px overflow-hidden rounded-xl bg-white/10 sm:grid-cols-2 lg:grid-cols-5" data-id="element-207" data-mp="gqtjjteiocfj">
          {pillars.map((pillar, index) => <div key={pillar.title} className="bg-ink-900 p-6" data-id="element-208" data-mp="bs8qcdxomt0l" data-mpi={index}>
              <span className="text-xs font-bold tabular-nums text-flare-500" data-id="element-209" data-mp="3k8bnvqv2z1b7">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 text-base font-bold uppercase tracking-wide" data-id="element-210" data-mp="3g81hid3dm8vt">{pillar.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-211" data-mp="3u33pd5rsa8b9">{pillar.detail}</p>
            </div>)}
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-3xl px-6 text-center" data-id="element-212" data-mp="19efxnvldezgn">
        <p className="text-xl font-semibold leading-relaxed text-white" data-id="element-213" data-mp="19h20xj18ast2">
          Por USD 17, dejas de juntar tutoriales sueltos y entiendes el cielo: puedes operar sin
          miedo y con credibilidad ante clientes.
        </p>
      </div>
    </section>;
}